import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class CancelPlaceOrderUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.cancelPlaceOrder(req);
    }
}
export default CancelPlaceOrderUseCase;
